// Link components carry the current query forward so filter state survives
// navigation. Spreading `route.query` wholesale carried *anything* that arrived
// too, including junk — and because every link on the page re-emitted it, each
// crawl hop added another layer. Observed in production: query keys nested 43
// `amp;` levels deep, renders taking up to 55s, 97% of all CPU time.
//
// Only carry params the app actually reads. Anything else is dropped, so a
// malformed URL dies at the first page instead of multiplying.
//
// Keep in sync with the params read across pages/ and components/:
//   year, month           events + exhibitions filters
//   block, item           list-with-popup
//   page, tagId           journals
//   pressPage, pressKitPage  press
//   modal                 modal routes
const CARRIED_PARAMS = [
  'year',
  'month',
  'block',
  'item',
  'page',
  'tagId',
  'pressPage',
  'pressKitPage',
  'modal'
]

export const filterRouteQuery = (query: Record<string, any> = {}) => {
  if (!query) return {}

  return CARRIED_PARAMS.reduce((carried: Record<string, string>, param) => {
    const value = query[param]

    if (value === undefined || value === null || value === '') return carried

    // Repeated params (?month=1&month=2) arrive as arrays. Collapse to the last
    // value so they cannot accumulate across navigations either.
    carried[param] = String(Array.isArray(value) ? value[value.length - 1] : value)

    return carried
  }, {})
}
